import Head from 'next/head';

export default function OrganizationSchema() {
  const educationalSchemaMarkup = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: 'Rockalingua',
    url: 'https://rockalingua.com',
    logo: 'https://cdn.rockalingua.com/production/static/img/rockaLogo.png',
    description:
      'Rockalingua is an educational platform that offers songs, videos, and games to make learning Spanish fun for kids.',
    sameAs: [
      'https://www.facebook.com/Rockalingua/',
      'https://www.instagram.com/rockalingua',
      'https://www.youtube.com/@Rockalingua',
    ],
    founder: {
      '@type': 'Person',
      name: 'César Álvarez',
    },
  };

  return (
    <Head>
      <script
        id="organization-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(educationalSchemaMarkup),
        }}
      />
    </Head>
  );
}
